(() => {
  const termsLabelSelector = 'label[for^="rterms-"] p';

  const removeAdditionalTermsCopy = (paragraph) => {
    const termsLink = [...paragraph.querySelectorAll('a')].find((link) => {
      const href = link.getAttribute('href') || '';
      const text = link.textContent || '';
      return href.includes('/pages/terms-of-service') || /terms\s*(?:&|and)?\s*conditions/i.test(text);
    });

    if (!termsLink) return;

    let sibling = termsLink.nextSibling;
    while (sibling) {
      const nextSibling = sibling.nextSibling;
      sibling.remove();
      sibling = nextSibling;
    }
  };

  const updateTermsLabels = () => {
    document.querySelectorAll(termsLabelSelector).forEach(removeAdditionalTermsCopy);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateTermsLabels, { once: true });
  } else {
    updateTermsLabels();
  }

  new MutationObserver(updateTermsLabels).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
